import { render, staticRenderFns } from "./Modal.captureCamera.vue?vue&type=template&id=03766496&"
import script from "./Modal.captureCamera.vue?vue&type=script&lang=ts&"
export * from "./Modal.captureCamera.vue?vue&type=script&lang=ts&"
import style0 from "./Modal.captureCamera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports